import Transformer from "@/utils/transformer"

export default class UpdateSub{

    static IMMEDIATE = 100
    static END_OF_TERM = 200
    static SPECIFIC_DATE = 300

    static hpContent() {
        return window?.hpData?.content ?? {}
    }
    static isCheckoutExisting() {
        return this.hpContent().type == "checkout_existing"
    }
    static isScheduledChange() {
        return !!this.hpContent()?.subscription?.change_option
    }
    static getSubChangeDate() {
        if(this.hpContent()?.subscription?.changes_scheduled_at) {
            var changeDate = this.hpContent().subscription.changes_scheduled_at
            var ts = Transformer.getTimestampFromDate(changeDate)
            return ts
        }
        return ''
    }
    static isImmediateChargePresent(orderEstimateHolder) {
        return  !!orderEstimateHolder && 
                !!orderEstimateHolder.immediateEstimate && 
                !!orderEstimateHolder.immediateEstimate.line_items && 
                orderEstimateHolder.immediateEstimate.line_items.length > 0;
    }
}